import React, { useEffect, useState } from 'react'
import TrainEvent from './TrainEvent.js'
import CarEvent from './CarEvent.js'
import TrainEnthusiastEvent from './TrainEnthusiastEvent.js'
import VestGuyEvent from './VestGuyEvent.js';
import CrossingArmBack from "./CrossingArmBack";
import CrossingArmFront from "./CrossingArmFront";

const GenericRoadEvent = props => {

    const [animateObject, setAnimateObject] = useState(0);

    const styleObject = {       
        transform: `translate3d(${
            props.xOffset
        }%, ${
            props.yOffset
        }%, ${
            // props.zOffset - carDistance
            (props.position - props.zOffset) - animateObject
        }px)`,
        zIndex: props.zIndex
    }

    const RegisterEventType = type => { 
        if (type.toLowerCase() === 'train') {
            return <TrainEvent {...props} />
        }
    
        if (type.toLowerCase() === 'train-enthusiast') {
            return <TrainEnthusiastEvent {...props} />
        }
        if (type.toLowerCase() === 'car') {
            return <CarEvent {...props} setAnimateObject={setAnimateObject} />
        }
        if (type.toLowerCase() === 'vest-guy') {
            return <VestGuyEvent {...props} />
        }
        if (type.toLowerCase() === 'crossing-bar-back') {
            return <CrossingArmBack {...props} />
        }
        if (type.toLowerCase() === 'crossing-bar-front') {
            return <CrossingArmFront {...props} />
        }
    }

    return (       
        <div className={`GenericRoadEvent`} style={styleObject} >
            {RegisterEventType(props.type)}
        </div>
    )
}

export default GenericRoadEvent